import httpService from "./http.service"

const withSignal = (config, signal) => (signal ? { ...config, signal } : config)

const recordService = {
  getRecords: async (filters = {}, options = {}) => {
    const params = {}
    if (filters.date) params.date = filters.date
    if (filters.dateFrom) params.date_from = filters.dateFrom
    if (filters.dateTo) params.date_to = filters.dateTo
    if (filters.userId != null) params.user_id = filters.userId
    if (filters.clientId != null) params.client_id = filters.clientId
    if (filters.serviceId != null) params.service_id = filters.serviceId
    if (filters.status) params.status = filters.status
    if (filters.limit != null) params.limit = filters.limit
    if (filters.offset != null) params.offset = filters.offset
    if (filters.qId) params.q_id = filters.qId
    if (filters.qService) params.q_service = filters.qService
    if (filters.qClient) params.q_client = filters.qClient
    if (filters.qMaster) params.q_master = filters.qMaster
    if (filters.qAuthor) params.q_author = filters.qAuthor
    if (filters.qTime) params.q_time = filters.qTime
    if (filters.qStatus) params.q_status = filters.qStatus
    if (filters.qPrice) params.q_price = filters.qPrice
    if (filters.qForecast) params.q_forecast = filters.qForecast
    if (filters.qCreated) params.q_created = filters.qCreated
    if (filters.createdFrom) params.created_from = filters.createdFrom
    if (filters.createdTo) params.created_to = filters.createdTo
    if (filters.withTotal) params.with_total = 1
    if (filters.sort) params.sort = filters.sort
    if (filters.sortDir) params.sort_dir = filters.sortDir
    const { data } = await httpService.get(
      "api/records/",
      withSignal({ params }, options.signal)
    )
    return data
  },
  getRecordById: async (recordId, options = {}) => {
    const { data } = await httpService.get(
      `api/records/record/${recordId}/`,
      withSignal({}, options.signal)
    )
    return data
  },
  getRecordsByDate: async (date, options = {}) => {
    const params = {}
    if (options.userId != null) params.user_id = options.userId
    if (options.limit != null) params.limit = options.limit
    if (options.offset != null) params.offset = options.offset
    const { data } = await httpService.get(
      `api/records/by-date/${date}`,
      withSignal({ params }, options.signal)
    )
    return data
  },
  deleteBreak: async (recordId) => {
    const { data } = await httpService.get(`api/records/delete-break/${recordId}`)
    return data
  },
  getAvailableRecords: async (
    selectedServiceId,
    selectedUserId,
    boardDayDate
  ) => {
    const { data } = await httpService.get(
      `api/records/get-available/${selectedServiceId}/${selectedUserId}/${boardDayDate}`
    )
    return data
  },
  getAvailableCrmRecords: async (userId, selectedUserId, boardDayDate) => {
    const { data } = await httpService.get(
      `api/records/get-available-crm/${userId}/${selectedUserId}/${boardDayDate}`
    )
    return data
  },
  getAvailableRecordsBatch: async (selectedUserId, dates, options = {}) => {
    const params = {
      user_id: selectedUserId,
      dates: dates.join(","),
    }
    if (options.duration) params.duration = options.duration
    if (options.serviceId) params.service_id = options.serviceId
    if (options.selectedSlots?.length) {
      params.selected_slots = JSON.stringify(options.selectedSlots)
    }
    const { data } = await httpService.get(
      "api/records/availability-batch/",
      withSignal({ params }, options.signal)
    )
    return data
  },
  getAvailableCrmRecordsBatch: async (userId, masterId, dates, options = {}) => {
    const params = {
      user_id: userId,
      dates: dates.join(","),
    }
    if (options.masterIds?.length) {
      params.master_ids = options.masterIds.join(",")
    } else if (masterId != null) {
      params.master_id = masterId
    }
    if (options.duration) params.duration = options.duration
    if (options.serviceId) params.service_id = options.serviceId
    if (options.selectedSlots?.length) {
      params.selected_slots = JSON.stringify(options.selectedSlots)
    }
    const { data } = await httpService.get(
      "api/records/availability-crm-batch/",
      withSignal({ params }, options.signal)
    )
    return data
  },
  UpdateRecord: async (payload) => {
    const { data } = await httpService.patch(
      "api/records/record/" + payload.recordId,
      payload
    )
    return data
  },
  CancelRecord: async ({ recordId }) => {
    await httpService.post("api/records/cancel", { recordId })
  },
  createNewRecord: async (recordData) => {
    const { data } = await httpService.post("api/records/", recordData)
    return data
  },
  createNewRecordWithRegister: async (recordData) => {
    const { data } = await httpService.post(
      "api/records/register-and-record",
      recordData
    )
    return data
  },
  createNewComplex: async (recordData) => {
    const { data } = await httpService.post("api/records/complex", recordData)
    return data
  },
  createNewComplexWithRegister: async (recordData) => {
    const { data } = await httpService.post(
      "api/records/complex-with-register",
      recordData
    )
    return data
  },
  UploadRecordImage: async (recordId, formData) => {
    await httpService.patch("api/records/image/" + recordId, formData)
  },
  deleteRecord: async (recordId) => {
    const { data } = await httpService.delete(`api/records/record/${recordId}/`)
    return data
  },
  deleteRecordsBulk: async (ids) => {
    const { data } = await httpService.post("api/records/bulk-delete/", { ids })
    return data
  },
}

export default recordService
